import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Collapse,
  notification,
  Tooltip,
  Popconfirm,
} from "antd";
import TableComponent from "../../components/TableComponent";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaInbox } from "react-icons/fa";
import moment from "moment/moment";
import createBDFExcel from "../../../../utils/createBDFExcel";
import isEmailAllowed from "../../../../utils/isEmailAllowed";
import formatIndianNumber from "../../../../utils/formatIndianNumber";
import { useDispatch } from "react-redux";
import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import isAbleToModifyBooking from "../../../../utils/isAbleToModifyBooking";
import { PiPencilSimpleFill, PiPencilSimpleSlashFill } from "react-icons/pi";
import { MdDeleteForever } from "react-icons/md";
import { MdDelete } from "react-icons/md";
let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const PendingBDFContainer = ({ filtersBDF }) => {
  const [bookingsModalOpen, setBookingsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  let userEmail = useSelector((state) => state.user.email);
  // const [fetchFlag,setFetchFlag]
  const [BDFData, setBDFData] = useState(null);
  const [fetched, setFetched] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  async function run() {
    let data = await fetchBdfData();
    if (data) {
      setBDFData(data);
    }
  }
  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    run();
  }, [fetched]);

  useEffect(() => {
    fetchDataWithFilters();
  }, [filtersBDF]);

  async function fetchDataWithFilters() {
    let data = await fetchBdfData();
    if (data) {
      setBDFData(data);
    }
  }

  async function fetchBdfData() {
    try {
      let query = [];

      if (filtersBDF.client) {
        query.push(`client=${filtersBDF.client}`);
      }

      if (filtersBDF.createdBy) {
        query.push(`createdBy=${filtersBDF.createdBy}`);
      }

      if (
        filtersBDF.dateRange &&
        filtersBDF.dateRange[0] &&
        filtersBDF.dateRange[1]
      ) {
        query.push(`startDate=${filtersBDF.dateRange[0]}`);
        query.push(`endDate=${filtersBDF.dateRange[1]}`);
      }

      const queryString = query.length > 0 ? `?${query.join("&")}` : "";
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getBdfData${queryString}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let responseJson = await response.json();
      let data = responseJson.data;
      return data;
    } catch (err) {
      console.error(`Error: ${err.message}`);
    }
  }

  //This following code handles the so called unaccepted BDFs
  function checkIfUnAcceptedExist(bdfdata) {
    return bdfdata?.BDFDetails?.some((ele) => !ele.accepted) || false;
  }

  let dataClients2 = BDFData?.reduce((acc, ele, ind) => {
    if (checkIfUnAcceptedExist(ele)) {
      const clientInfo = {
        key: ind + 1,
        label: `Client: ${ele?.partyCompanyName}`,
        children: (
          <ClientInfo
            bookings={ele}
            run={run}
            userEmail={userEmail}
            setFetched={setFetched}
          />
        ),
      };
      acc.push(clientInfo);
    }
    return acc;
  }, []);

  return (
    // <div className="parent-padding-container">
    <div>
      {/* <h4 style={{fontSize:"20px", marginBottom: "2rem" }}>On-Hold Bookings</h4> */}

      {/* <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "end" }}>
                    <AddNewClientComponent />
                </div> */}
      {dataClients2 && dataClients2.length > 0 ? (
        <Collapse items={dataClients2} accordion defaultActiveKey={["1"]} />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            justifyContent: "center",
            fontSize: "20px",
            fontWeight: "600",
            color: "gray   ",
          }}
        >
          <FaInbox /> No OnHold-Bookings Yet
        </div>
      )}
    </div>
    // </div>
  );
};

export default PendingBDFContainer;

const ClientInfo = ({ bookings, run, userEmail, setFetched }) => {
  const [bookingsModalOpen, setBookingsModalOpen] = useState(false);
  const [detailedBookingsData, setDetailedBookingsData] = useState(null);
  const [packageRate, setPackageRate] = useState(null);
  const navigate = useNavigate();
  let userId = useSelector((state) => state.user._id);

  console.log("user id is: ", userId);
  // const [inventories,setInventories]=useState(null);
  // const [bdfDetails,setBdfDetails]=useState(null);

  function handleViewBookings(invs, PRate) {
    setPackageRate(null);
    let data = invs
      ?.filter((ele) => !ele?.suffixCode)
      .map((ele) => {
        return {
          CodeNo: ele?.invId?.CodeNo,
          area: ele?.invId?.locations?.name,
          mountingCharge: ele?.mountingCharge,
          printingCharge: ele?.printingCharge,
          specialRate: ele?.specialRate,
          startDate: moment(ele?.startDate).format("DD-MM-YYYY"),
          endDate: moment(ele?.endDate).format("DD-MM-YYYY"),
        };
      });
    setDetailedBookingsData(data);
    setPackageRate(PRate);
    setBookingsModalOpen(true);
  }

  async function handleApproveBDF(id) {
    let postData = { id };
    let response = await fetch(
      `${apiBaseUrl}/inventoryManagement/update-bdf-status`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      }
    );

    let responseJson = await response.json();
    if (!response.ok) {
      notification.error({ message: responseJson.message });
    }
    if (responseJson.success) {
      notification.success({ message: responseJson.message });
      run();
    }
  }

  function handleBookingClick(inventories, bdfDetails) {
    createBDFExcel(bdfDetails, inventories);
    //  setBdfDetails(bdfDetails);
    //  setInventories(inventories);
  }

  const handleDeleteBDF = async (id) => {
    try {
      let requestBody = {
        bdfId: id,
      };
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/deleteOBdf`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJson = await response.json();
      if (!response.ok) {
        notification.error({ message: responseJson.message });
      }
      if (responseJson.success) {
        notification.success({ message: responseJson.message });
        setFetched((prev) => !prev);
      }
    } catch (err) {
      console.error("Error: ", err.message);
    }
  };

  const columnBookings = isEmailAllowed(userEmail)
    ? [
        {
          title: "Serial No.",
          dataIndex: "serial",
          key: "serial",
        },
        {
          title: "Booked On",
          dataIndex: "date",
          key: "date",
        },
        {
          title: "Campaign Name",
          dataIndex: "campaignName",
          key: "campaignName",
        },
        {
          title: "Created by",
          dataIndex: "createdBy",
          key: "createdBy",
        },
        {
          title: "View",
          dataIndex: "view",
          key: "view",
          render: (text, record) => (
            <Button
              onClick={() =>
                handleViewBookings(record.inventories, record.packageRate)
              }
            >
              View More
            </Button>
          ),
        },
        // {
        //   title: "BDF",
        //   dataIndex: "bdf",
        //   key: "bdf",
        //   render: (text, record) => (
        //     <Button onClick={() => handleBookingClick(record.inventories, record.bdfDetails)}>
        //       BDF
        //     </Button>
        //   ),
        // },
        {
          title: "Approve",
          dataIndex: "Approve",
          key: "approve",
          render: (text, record) => (
            <Button onClick={() => handleApproveBDF(record?.bdfDetails?._id)}>
              Approve
            </Button>
          ),
        },
        {
          title: "Edit",
          dataIndex: "Edit",
          key: "edit",
          render: (text, record) => (
            isAbleToModifyBooking(record?.creatorId, userId) ? (
              <Button onClick={() => handleEditBDF(record?.bdfDetails?._id)} style={{ border: 'none' }}>
                <PiPencilSimpleFill />
              </Button>
            ) : (
              <>
                <Tooltip title="Editing not allowed">
                  <PiPencilSimpleSlashFill />
                </Tooltip>
              </>
            )
          ),
        },
        {
          title: "Delete",
          dataIndex: "delete",
          key: "delete",
          render: (text, record) =>
            isAbleToModifyBooking(record?.creatorId, userId) ? (
              <Popconfirm
                title="Delete Booking"
                placement="topRight"
                description="Are you sure you want to delete?"
                onConfirm={() => handleDeleteBDF(record?.bdfDetails?._id)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <MdDelete
                  style={{ color: "red", fontSize: "1rem", cursor: "pointer" }}
                />
              </Popconfirm>
            ) : (
              <Tooltip title="Deleting not allowed">
                <MdDeleteForever style={{ color: "gray", fontSize: "1rem" }} />
              </Tooltip>
            ),
        },
      ]
    : [
        {
          title: "Serial No.",
          dataIndex: "serial",
          key: "serial",
        },
        {
          title: "Booked On",
          dataIndex: "date",
          key: "date",
        },
        {
          title: "Created by",
          dataIndex: "createdBy",
          key: "createdBy",
        },
        {
          title: "View",
          dataIndex: "view",
          key: "view",
          render: (text, record) => (
            <Button onClick={() => handleViewBookings(record.inventories)}>
              View More
            </Button>
          ),
        },
        {
          title: "Edit",
          dataIndex: "Edit",
          key: "edit",
          render: (text, record) => (
            isAbleToModifyBooking(record?.creatorId, userId) ? (
              <Button onClick={() => handleEditBDF(record?.bdfDetails?._id)} style={{ border: 'none' }}>
                <PiPencilSimpleFill />
              </Button>
            ) : (
              <>
                <Tooltip title="Editing not allowed">
                  <PiPencilSimpleSlashFill />
                </Tooltip>
              </>
            )
          ),
        },
        {
          title: "Delete",
          dataIndex: "delete",
          key: "delete",
          render: (text, record) =>
            isAbleToModifyBooking(record?.creatorId, userId) ? (
              <Popconfirm
                title="Delete Booking"
                placement="topRight"
                description="Are you sure you want to delete?"
                onConfirm={() => handleDeleteBDF(record?.bdfDetails?._id)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <MdDelete
                  style={{ color: "red", fontSize: "1rem", cursor: "pointer" }}
                />
              </Popconfirm>
            ) : (
              <Tooltip title="Deleting not allowed">
                <MdDeleteForever style={{ color: "gray", fontSize: "1rem" }} />
              </Tooltip>
            ),
        },
      ];

  const detailedBookingsColumn = [
    {
      title: "Code",
      dataIndex: "CodeNo",
      key: "CodeNo",
    },
    {
      title: "Location",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "Mounting Charge",
      dataIndex: "mountingCharge",
      key: "mountingCharge",
    },
    {
      title: "Printing Charge",
      dataIndex: "printingCharge",
      key: "printingCharge",
    },
    {
      title: "Special Rate Per Month",
      dataIndex: "specialRate",
      key: "specialRate",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "start Date",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
  ];

  const handleEditBDF = (id) => {
    navigate(`/clients-bdf-edit/${id}?type=onHold`);
  };

  const handleEditOnHoldBDF = (id) =>{
    navigate(`/clients-bdf-edit/${id}?type=onHold`)
  }


  const dataBookings = bookings?.BDFDetails?.reduce((acc, ele, ind) => {
    if (!ele.accepted) {
      const { inventories, ...bdfDetails } = ele;
      acc.push({
        serial: ele?.stamp,
        date: moment(ele?.createdAt).format("DD-MM-YYYY"),
        bdfDetails,
        createdBy: ele?.createdBy?.name,
        inventories,
        packageRate: ele?.packageRate,
        creatorId: ele?.createdBy?._id,
        campaignName:ele?.campaignName,
      });
    }
    return acc;
  }, []);
  return (
    <>
      <div>
        <h4 style={{ color: "gray", marginBottom: "1rem" }}>Client Info</h4>
        <div style={{ display: "flex", gap: "2rem", marginBottom: "1rem" }}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div style={{ color: "gray" }}>Name: </div>
            <div>{bookings?.contactPerson}</div>
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div style={{ color: "gray" }}>Email: </div>
            <div>{bookings?.emailId}</div>
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div style={{ color: "gray" }}>Contact: </div>
            <div>{bookings?.contactNumber}</div>
          </div>
        </div>
        <h4 style={{ color: "gray" }}>Bookings Info</h4>
        <div>
          <TableComponent dataSource={dataBookings} columns={columnBookings} />
        </div>

        <Modal
          title="Bookings"
          open={bookingsModalOpen}
          onCancel={() => {
            setBookingsModalOpen(false);
          }}
          onOk={() => {
            setBookingsModalOpen(false);
          }}
          centered
          className="inventory-proposal-modal"
          width={800}
        >
          <div className="bdfbased-booking-detail">
            <TableComponent
              dataSource={detailedBookingsData}
              columns={detailedBookingsColumn}
            />
            {packageRate && (
              <div
                style={{ display: "flex", alignItems: "center", gap: ".5rem" }}
              >
                <h6 style={{ margin: "0" }}>
                  Package Rate : ₹ {formatIndianNumber(packageRate)}
                </h6>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};
